<template>
  <validation-provider
    :name="field.name"
    :rules="rules"
    v-slot="validationContext"
  >
    <b-form-group :label="field.label || ''" :description="field.description || ''">
      <b-form-select
        :options="options"
        :size="size"
        v-model="inputValue"
        :disabled="disabled"
        :state="getValidationState(validationContext)"
      >
        <template #first>
          <b-form-select-option :value="undefined" disabled>{{ field.placeholder }}</b-form-select-option>
        </template>
      </b-form-select>
      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>
<script>
export default {
  props: {
    value: {
      type: String
    },
    rules: {
      type: Object
    },
    options: {
      type: Array
    },
    size: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    field: {
      type: Object,
      validate: (v) => {
        return !!v;
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    } 
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    }
  }
}
</script>